

import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ApiAdminAllowedSenderDomainsService} from "../../../../../services/api/admin/admin-allowed-sender-domains-api/admin-allowed-sender-domains-api.service";
import {DialogService} from "../../../../../services/dialog-service/dialog.service";
import {AdminAllowedSenderDomainsComponentDialog} from "./admin-allowed-sender-domains-create-edit-dialog/admin-allowed-sender-domains-create-edit-dialog.component";
import {ModalConfirmationComponent} from "../../../../../shared/modal-confirmation/modal-confirmation.component";

@Component({
  selector: 'app-admin-allowed-sender-domains',
  templateUrl: './admin-allowed-sender-domains.html'
})
export class AdminAllowedSenderDomainsComponent implements OnInit {

  data;
  isLoading = true;

  constructor(private apiAdminAllowedSenderDomainsService: ApiAdminAllowedSenderDomainsService, private dialogService: DialogService, private viewReference: ViewContainerRef) {
    this.getData();
  }

  ngOnInit(): void {
  }

  getData(){
    this.isLoading = true;
    this.apiAdminAllowedSenderDomainsService.listAll().then(response => {
      this.data = response;
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      if (error.status === 403) {
        window.location.href = '/';  // Redirect to self-service
      } else {
        console.log('Unhandled error:', error);
      }
    });
  }

  create(){
    // Replace null with Component
    this.dialogService.createDialog(AdminAllowedSenderDomainsComponentDialog, null, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  edit(id){
    // Replace null with Component
    this.dialogService.createDialog(AdminAllowedSenderDomainsComponentDialog, id, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  delete(id){
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.apiAdminAllowedSenderDomainsService.delete(id).then(response => this.getData())
      }, cancelled => null)
  }



}
